module.exports = __webpack_public_path__ + "static/img/毅都概览-1.fd1f3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/毅都概览-1.png
// module id = x4fr
// module chunks = 38